<template>
  <section class="d-flex flex-column h-full">
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      staticMode="true"
    >
    </TopAppBar>
    <TopAppBarDrawer
      :isDrawerOpen="isDrawerOpen"
      @closeDrawer="closeDrawer"
    ></TopAppBarDrawer>
    <div class="flex-grow-1 scroll-y">
      <LeaderList></LeaderList>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </section>
</template>

<script>
/**
 * 나의 학습 메인 컴포넌트(my learn main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import TopAppBar from "@/components/TopAppBar.vue";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import LeaderList from "@/components/leader/List";

export default {
  name: "learn",

  components: {
    TopAppBar,
    LeaderList,
    TopAppBarDrawer,
  },

  mixins: [topAppBarMixin],

  data() {
    return {
      isDrawerOpen: false,
    };
  },

  mounted() {
    this.leftBtnMode = "menu";
    this.leftBtnMethod = this.openDrawer;
  },

  methods: {
    openDrawer() {
      this.isDrawerOpen = true;
    },

    closeDrawer() {
      this.isDrawerOpen = false;
    },
  },
};
</script>